import type { ReactNode } from 'react'
import { useTheme } from '../hooks/useTheme'
import { getPageContainerStyles } from '../utils/safeArea'

interface LayoutProps {
  children: ReactNode
}

/**
 * Main layout component that wraps all routes
 * Automatically handles safe area insets, theme colors, and bottom navigation padding
 * All page components automatically inherit these styles without needing to add them
 * 
 * @example
 * <Layout>
 *   <Routes>
 *     <Route path="/" element={<Dashboard />} />
 *   </Routes>
 * </Layout>
 */
export function Layout({ children }: LayoutProps) {
  const theme = useTheme()

  return (
    <div
      className="min-h-screen"
      style={{
        ...getPageContainerStyles(theme.bgColor, theme.textColor),
        // Override bottom padding to account for bottom navigation (h-14 = 3.5rem + 0.5rem top + 0.5rem bottom = 4.5rem)
        paddingBottom: `calc(4.5rem + env(safe-area-inset-bottom, 0px))`,
        // Override left and right padding to exclude safe area insets (keep only base padding)
        paddingLeft: '0rem',
        paddingRight: '0rem',
      }}
    >
      {children}
    </div>
  )
}
